/* eslint-disable max-len */
import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import Chest from '../animations/chest';
import AnalogClock from '../clocks/analog';
import DigitalClock from '../clocks/digital';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.MatchingChests.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundsSorting.GameData;
  this.difficulty = 1;
  this.iteration = 0;

  this.SLOTS_SUMMARY_WIDTH = 0;
  this.SLOT_WIDTH = 0;
  this.START_X = 0;
  this.chests = [];
  this.digitalClocks = [];
  this.analogClocks = [];
  this.dropZones = [];
  this.randomClocks = [];
};
/**
 *
 */
EDC.Games.MatchingChests.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.MatchingChests.Scenes.Main.prototype.constructor = EDC.Games.MatchingChests.Scenes.Main;

EDC.Games.MatchingChests.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.add.sprite(this.game.config.width / 2, 1030, 'title');
  this.loadIteration();

  this.createBasicUI();
};

EDC.Games.MatchingChests.Scenes.Main.prototype.loadIteration = function () {
  // constants
  this.SLOTS_SUMMARY_WIDTH = 1850;
  this.SLOT_WIDTH = this.SLOTS_SUMMARY_WIDTH / this.gameConfig.sets[this.difficulty].iterations[this.iteration].values.length;
  this.START_X = (this.game.config.width - this.SLOTS_SUMMARY_WIDTH) / 2;

  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].values.length; i++) {
    this.randomClocks.push(this.gameConfig.sets[this.difficulty].iterations[this.iteration].values[i]);
  }

  this.createChests();
  this.createDigitalClocks();
  this.createAnalogClocks();
  this.createDropZones();
};

EDC.Games.MatchingChests.Scenes.Main.prototype.getRandomClock = function () {
  const index = Math.floor(Math.random() * this.randomClocks.length);
  const res = this.randomClocks.splice(index, 1);
  if (res.length) {
    return res[0];
  }
  return null;
};
/**
 *
 */
EDC.Games.MatchingChests.Scenes.Main.prototype.createDropZones = function () {
  const zoneWidth = this.SLOT_WIDTH - 50;
  const step = (this.SLOT_WIDTH - zoneWidth) / 2;
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].values.length; i++) {
    const zone = new Phaser.Geom.Rectangle(this.START_X + this.SLOT_WIDTH * i + step, 550, zoneWidth, 430);
    this.dropZones.push(zone);
  }
};
/**
 *
 */
EDC.Games.MatchingChests.Scenes.Main.prototype.clockDropped = function (clock) {
  let zoneIndex = -1;
  let i;
  for (i = 0; i < this.dropZones.length; i++) {
    if (this.dropZones[i].contains(clock.container.x, clock.container.y)) {
      zoneIndex = i;
      break;
    }
  }
  if (zoneIndex >= 0) {
    const dc = this.digitalClocks[i];
    if (dc.time.hours === clock.time.hours && dc.time.minutes === clock.time.minutes) {
      this.cursorManager.resetCursor();
      clock.hide();
      this.playCorrect();
      this.chests[zoneIndex].playFull();
    } else {
      clock.moveBack();
      this.chests[zoneIndex].playEmpty();
      this.playWrong();
    }
  } else {
    clock.moveBack();
  }

  let isAllChestsOpened = true;
  for (let j = 0; j < this.chests.length; j++) {
    if (!this.chests[j].isBlocked) {
      isAllChestsOpened = false;
      break;
    }
  }
  if (isAllChestsOpened) {
    this.time.delayedCall(1500, this.nextIteration, [], this);
  }
};

EDC.Games.MatchingChests.Scenes.Main.prototype.nextIteration = function () {
  this.chests.map((chest) => {
    chest.destroyChest();
    return true;
  });
  this.digitalClocks.map((x) => {
    x.destroyDigital();
    return true;
  });
  this.analogClocks.map((x) => {
    x.destroyAnalog();
    return true;
  });

  this.digitalClocks = [];
  this.analogClocks = [];
  this.chests = [];
  this.randomClocks = [];
  this.dropZones = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

EDC.Games.MatchingChests.Scenes.Main.prototype.createChests = function () {
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].values.length; i++) {
    const x = this.START_X + this.SLOT_WIDTH * i + this.SLOT_WIDTH / 2;
    const chest = new Chest(this, x, 730);
    chest.create();
    this.chests.push(chest);
  }
};
/**
 *
 */
EDC.Games.MatchingChests.Scenes.Main.prototype.createDigitalClocks = function () {
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].values.length; i++) {
    const data = this.gameConfig.sets[this.difficulty].iterations[this.iteration].values[i];
    const x = this.START_X + this.SLOT_WIDTH * i + this.SLOT_WIDTH / 2;
    const clock = new DigitalClock(this);
    clock.create();
    clock.place(x, 870);
    clock.setTime(data.hour, data.minute);
    this.digitalClocks.push(clock);
  }
};
/**
 *
 */
EDC.Games.MatchingChests.Scenes.Main.prototype.createAnalogClocks = function () {
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].values.length; i++) {
    const data = this.getRandomClock();
    const x = this.START_X + this.SLOT_WIDTH * i + this.SLOT_WIDTH / 2;
    const clock = new AnalogClock(this, i + 1);
    clock.create();
    clock.place(x, 200);
    clock.setTime(data.hour, data.minute);
    this.analogClocks.push(clock);
  }
};

export default EDC.Games.MatchingChests.Scenes.Main;
